import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import * as _ from "lodash";
import { interpret } from "xstate";
import simplebar from "simplebar-vue";
// SYSTEMONE
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import AssetMasterUpsertComponent from "./components/AssetMasterUpsertComponent.vue";
import AssetPropertiesUpsertComponent from "./components/AssetPropertiesUpsertComponent.vue";
import assetMasterMachine from "./machines/AssetMasterMachine";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { AssetTypeModel } from "@/store/models/asset/assetType";
import { AssetTypePropertyModel } from "@/store/models/asset/assetTypeProperty";
import Swal from "sweetalert2";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
let AssetMaster = /** @class */ (() => {
    let AssetMaster = class AssetMaster extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.title = "Asset Master";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Asset Master",
                    active: true,
                },
            ];
            this.searchKey = "";
            this.newAssetType = null;
            this.AssetTypeUnderEdit = null;
            this.newAssetTypeProperty = null;
            this.isEdit = false;
            this.AssetTypePropertyEdit = null;
            this.selectedDeleteAssetTypeId = "";
            this.selectedDeleteAssetTypePropertiesId = "";
            this.displayingDetails = false;
            //   MACHINE
            this.machine = assetMasterMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        //   METHODS
        send(event) {
            this.machineService.send(event);
        }
        getAssetType() {
            return this.assetTypes.find((x) => x.id == this.selectedAssetTypeId).name;
        }
        selectAssetType(id) {
            this.selectedAssetTypeId = id;
            this.machine.context.id = this.selectedAssetTypeId;
            this.send({
                type: "LOAD_ASSET_TYPE_PROPERTIES",
                id: this.selectedAssetTypeId,
            });
        }
        addNewAssetType() {
            this.newAssetType = new AssetTypeModel();
            this.searchKey = "";
            this.send({ type: "ADDING_ASSET_TYPE" });
        }
        saveNewAssetType() {
            this.send({ type: "SAVE_ASSET_TYPE", newAssetType: this.newAssetType });
        }
        editAssetType(assetType) {
            this.AssetTypeUnderEdit = Object.assign({}, assetType);
            this.send({ type: "EDIT_ASSET_TYPE" });
        }
        amIaAssetTypeUnderEdit(assetType) {
            if (this.AssetTypeUnderEdit != null) {
                return this.AssetTypeUnderEdit.id == assetType.id;
            }
            return false;
        }
        updateAssetType() {
            this.send({
                type: "UPDATE_ASSET_TYPE",
                updateAssetType: this.AssetTypeUnderEdit,
            });
        }
        addAssetTypeProperty() {
            this.isEdit = false;
            this.newAssetTypeProperty = new AssetTypePropertyModel();
            this.send({ type: "ADDING_ASSET_TYPE_PROPERTY" });
        }
        setConfiguration() {
            this.send({ type: "SET_CONFIGURATION_ORDERS" });
        }
        ClearConfiguration() {
            this.send({
                type: "CLEAR_ALL_CONFIGURATION_ORDER",
                assetTypePropertyId: this.assetTypeProperty[0].id,
            });
        }
        saveAssetTypeProperty() {
            this.newAssetTypeProperty.assetTypeId = this.selectedAssetTypeId;
            this.send({
                type: "SAVING_ASSET_TYPE_PROPERTY",
                newAssetTypeProperty: this.newAssetTypeProperty,
            });
        }
        editAssetTypeProperty(item) {
            this.isEdit = true;
            this.AssetTypePropertyEdit = Object.assign({}, item);
            this.send({ type: "EDITING_ASSET_TYPE_PROPERTY" });
        }
        amIaAssetTypePropertyUnderEdit(item) {
            if (this.AssetTypePropertyEdit != null) {
                return this.AssetTypePropertyEdit.id == item.id;
            }
            return false;
        }
        updateAssetTypeProperty() {
            this.send({
                type: "UPDATE_ASSET_TYPE_PROPERTY",
                updatingAssetTypeProperty: this.AssetTypePropertyEdit,
            });
        }
        SelectedDeleteAssetType(assetTypeId, isAssetType) {
            if (isAssetType) {
                Swal.fire({
                    text: "Sorry! This Asset Type cannot be deleted. It has one or more Assets or Asset Type Properties associated with it.",
                    icon: "warning",
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "Okay",
                }).then(() => { });
            }
            else {
                this.send({ type: "DELETE_ASSET_TYPE" });
                this.selectedDeleteAssetTypeId = assetTypeId;
            }
        }
        SelectedDeleteAssetTypeProperties(assetTypePropertyId, isAssetTypeProperty) {
            if (isAssetTypeProperty) {
                Swal.fire({
                    text: "Sorry! This Asset Type Property cannot be deleted. It has one or more Assets associated with it.",
                    icon: "warning",
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "Okay",
                }).then(() => { });
            }
            else {
                this.send({ type: "DELETE_ASSET_TYPE_PROPERTY" });
                this.selectedDeleteAssetTypePropertiesId = assetTypePropertyId;
            }
        }
        closeModalAssetType() {
            this.send({ type: "CANCEL_DELETE_ASSET_TYPE" });
        }
        closeModalAssetTypeProperties() {
            this.send({ type: "CANCEL_DELETE_ASSET_TYPE_PROPERTY" });
        }
        closeAssetTypeProperty() {
            this.send({ type: "CLOSE_ASSET_TYPE_PROPERTIES" });
        }
        deleteAssetType() {
            this.send({
                type: "DELETING_ASSET_TYPE",
                assetTypeId: this.selectedDeleteAssetTypeId,
            });
        }
        deleteAssetTypeProperty() {
            this.send({
                type: "DELETING_ASSET_TYPE_PROPERTY",
                assetTypePropertyId: this.selectedDeleteAssetTypePropertiesId,
            });
        }
        setConfig(id, configOrder) {
            if (configOrder == null) {
                this.send({
                    type: "SAVING_CONFIGURATION_ORDER",
                    assetTypePropertyId: id,
                });
            }
            else {
                AssetMasterModule.ReSetConfigurationOrder(id);
            }
        }
        get assetTypes() {
            return _.sortBy(AssetMasterModule.assetTypes, (item) => item.name);
        }
        get assetTypeProperty() {
            return AssetMasterModule.assetTypeProperty;
        }
        get assetDataType() {
            return AssetMasterModule.assetDataType;
        }
        get assetControlType() {
            return AssetMasterModule.assetControlType;
        }
        get filteredAssetType() {
            if (this.searchKey != "") {
                return AssetMasterModule.assetTypes.filter((x) => x.name.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1 || x.code.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return AssetMasterModule.assetTypes;
        }
        get sortedFilteredAssetType() {
            return _.sortBy(this.filteredAssetType, (o) => o.name || o.code);
        }
        created() {
            this.machineService.onTransition((state) => {
                var prevState = this.state;
                this.state = state;
                if (state.matches("loadedAssetTypes")) {
                    this.AssetTypeUnderEdit = null;
                }
                if (state.matches("loadedAssetTypeProperties.listing")) {
                    this.AssetTypePropertyEdit = null;
                }
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    AssetMaster = __decorate([
        Component({
            name: "AssetMaster",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                AssetMasterUpsertComponent,
                AssetPropertiesUpsertComponent,
                SectionLoader,
                DeleteComponent,
            },
        })
    ], AssetMaster);
    return AssetMaster;
})();
export default AssetMaster;
